import { combineReducers } from '@reduxjs/toolkit';
import checkInReducer from 'redux/checkInSlice';
import officeContextReducer from 'redux/officeContextSlice';
import loginReducer from 'redux/loginSlice';
import snackBarReducer from 'redux/snackBarSlice';
import invitationReducer from 'redux/invitationSlice';

const rootReducer = combineReducers({
  logIn: loginReducer,
  snackBar: snackBarReducer,
  officeContext: officeContextReducer,
  checkIn: checkInReducer,
  invitation: invitationReducer
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
